module.exports = __webpack_public_path__ + "img/about_8_new.f8f8a27a.jpg";